import { render, staticRenderFns } from "./AiAnswerLottie.vue?vue&type=template&id=146e87db&"
import script from "./AiAnswerLottie.vue?vue&type=script&lang=js&"
export * from "./AiAnswerLottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports